'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconChartDiagramParentFocus, iconChartDiagramParentFocusTag } from '@ni/nimble-components/dist/esm/icons/chart-diagram-parent-focus';
import { wrap } from '../../utilities/react-wrapper';

export type { IconChartDiagramParentFocus };
export { iconChartDiagramParentFocusTag };
export const NimbleIconChartDiagramParentFocus = wrap(IconChartDiagramParentFocus);